import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { PublicRecording, UpdateRecordingDto } from "@classview/shared-types";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const updateRecording = async ({
  orgId,
  id,
  data,
}: {
  orgId: string;
  id: string;
  data: UpdateRecordingDto;
}): Promise<PublicRecording> => {
  const response = await axiosClient.patch(`/${orgId}/recordings/${id}`, data);
  return response.data;
};

function useUpdateRecording(
  mutationOptions?: Partial<
    UseMutationOptions<
      PublicRecording,
      HttpError,
      { orgId: string; id: string; data: UpdateRecordingDto }
    >
  >,
) {
  return useMutation({
    mutationFn: ({ orgId, id, data }) => updateRecording({ orgId, id, data }),
    ...mutationOptions,
  });
}
export { useUpdateRecording };
